import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useRef } from "react";
import "./CountryCombobox.css";
import AutocompleteArrow from "../../../../../components/AutocompleteDropdownArrow";

const CountryCombobox = ({ value, onChange, options = [], placeholder }) => {
  const divRef = useRef();

  // Find the display label for the current value
  const displayValue = options.find(
    (option) => option.code === value || option.value === value || option.name === value
  ) || null;

  return (
    <div ref={divRef} className="country-combobox-container">
      <Autocomplete
        disablePortal
        options={options}
        getOptionLabel={(option) => option.name || option.value || ""}
        value={displayValue}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.code || newValue.value || newValue.name : "");
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder || "Select country..."}
            variant="outlined"
            size="small"
          />
        )}
        popupIcon={<AutocompleteArrow />}
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: "4px",
            "& fieldset": {
              borderColor: "#e0e0e0",
              borderRadius: "8px",
            },
            "&:hover fieldset": {
              borderColor: "#c0c0c0",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1a3a52",
              borderWidth: "1px",
            },
          },
          "& .MuiInputBase-input": {
            fontSize: "14px",
            padding: "8px 10px !important",
            color: "#333 !important", // Ensure text is visible (dark color)
          },
          "& .MuiAutocomplete-input": {
            color: "#333 !important", // Ensure selected text is visible
          },
          "& .MuiAutocomplete-endAdornment": {
            right: "8px !important",
            top: "calc(50% - 12px)",
          },
        }}
      />
    </div>
  );
};

export default CountryCombobox;
